import React from "react";
import { motion } from "framer-motion";

const W1 = "M0,44 C240,92 480,8 720,52 C960,94 1200,18 1440,60 L1440,140 L0,140 Z";
const W2 = "M0,64 C240,18 480,96 720,40 C960,8 1200,84 1440,28 L1440,140 L0,140 Z";
const W3 = "M0,54 C240,100 480,20 720,66 C960,104 1200,30 1440,72 L1440,140 L0,140 Z";

// A liquid "ripple" seam that undulates between two sections.
export const RippleDivider = ({ top = "#F7F6F3", bottom = "#0A0A0A", height = 96, className = "" }) => (
  <div style={{ background: top }} className={`relative w-full overflow-hidden leading-[0] ${className}`} data-testid="ripple-divider">
    <svg viewBox="0 0 1440 140" width="100%" height={height} preserveAspectRatio="none" style={{ display: "block" }}>
      <motion.path fill={bottom} fillOpacity="0.35"
        initial={{ d: W2 }} animate={{ d: [W2, W3, W1, W2] }}
        transition={{ repeat: Infinity, duration: 11, ease: "easeInOut" }} />
      <motion.path fill={bottom}
        initial={{ d: W1 }} animate={{ d: [W1, W2, W3, W1] }}
        transition={{ repeat: Infinity, duration: 8, ease: "easeInOut" }} />
    </svg>
  </div>
);

export default RippleDivider;
